import { render, staticRenderFns } from "./BaseDeleteModal.vue?vue&type=template&id=c1d002e2&scoped=true"
import script from "./BaseDeleteModal.vue?vue&type=script&lang=js"
export * from "./BaseDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./BaseDeleteModal.vue?vue&type=style&index=0&id=c1d002e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1d002e2",
  null
  
)

export default component.exports